/**
 * Navigation constants for header and footer
 */

export const NAVIGATION = {
  SECURITY: {
    label: "Security",
    href: "/security",
  },
  CUSTOMERS: {
    label: "Customers",
    href: "/customers",
  },
  COMPANY: {
    label: "Company",
    href: "/company",
  },
  CAREERS: {
    label: "Careers",
    href: "https://www.workatastartup.com/companies/clarum",
    external: true,
  },
  CONTACT: {
    label: "Contact",
    href: "/contact",
  },
  LOGIN: {
    label: "Login",
    href: "https://app.clarum.ai",
    external: true,
  },
  TERMS: {
    label: "Terms of Use",
    href: "/terms-of-use",
  },
  PRIVACY: {
    label: "Privacy Policy",
    href: "/privacy",
  },
};
